'use client';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function PrintableHeroSkeleton() {
  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col xs={12}>
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Row>
            <Col md={6}>
              <Placeholder xs={12} style={{ height: '465px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <Placeholder xs={12} style={{ height: '220px' }} />
                  <Placeholder
                    xs={12}
                    style={{ marginBottom: '20px' }}
                    size="lg"
                  />
                </Col>
                <Col md={6}>
                  <Placeholder xs={12} style={{ height: '220px' }} />
                  <Placeholder
                    xs={12}
                    style={{ marginBottom: '20px' }}
                    size="lg"
                  />
                </Col>
                <Col md={6}>
                  <Placeholder xs={12} style={{ height: '220px' }} />
                  <Placeholder
                    xs={12}
                    style={{ marginBottom: '20px' }}
                    size="lg"
                  />
                </Col>
                <Col md={6}>
                  <Placeholder xs={12} style={{ height: '220px' }} />
                  <Placeholder
                    xs={12}
                    style={{ marginBottom: '20px' }}
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
